import { DSIcon, type DSIconName, type DSIconSize } from '@zoe/ds-web'
import type { FC } from 'react'
import styled from 'styled-components'

interface TypographyIconProps {
  name: DSIconName
  size?: DSIconSize
}

const StyledTypographyIcon = styled.span`
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  margin: 0 0.25em;
`

export const TypographyIcon: FC<TypographyIconProps> = ({ name, size = 16 }) => (
  <StyledTypographyIcon
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      verticalAlign: 'middle',
      margin: '0 0.25em',
    }}
  >
    <DSIcon name={name} size={size} />
  </StyledTypographyIcon>
)
